import { render, staticRenderFns } from "./VPrompt.vue?vue&type=template&id=48b17ac3&"
import script from "./VPrompt.vue?vue&type=script&lang=ts&"
export * from "./VPrompt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports